import React from 'react';
import ButtonCore from '../ButtonCore/ButtonCore';
import {
  ButtonSizes,
  ButtonTypes,
  ButtonVariants as ButtonVariantsCore,
} from '../ButtonCore/ButtonCore';
import { Icon } from '..';
// @ts-ignore
import classNames from 'classnames';
import styles from './Button.module.scss';
import { useAppContext } from '../../../AppContext';
import { StyleService } from '../../services';

enum ButtonVariants {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Link = 'link',
  Transparent = 'transparent',
  Icon = 'icon',
  Danger = 'danger',
}

type PropsType = {
  children: React.ReactNode;
  classNames?: string;
  inProgress?: boolean;
  variant: ButtonVariants;
  size?: ButtonSizes;
  id?: string;
  disabled?: boolean;
  type?: ButtonTypes;
  isUppercase?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  dataCy?: string;
  title?: string;
  ariaLabel?: string;
};

const Button = (props: PropsType) => {
  const context = useAppContext();
  const btnStyles = StyleService.apply(`general:btn:${props.variant || 'primary'}`, context.styles, true);
  const btnStylesHover = StyleService.apply(
    `general:btn:${props.variant || 'primary'}:hover`,
    context.styles,
    true
  );

  const handleOnClick = (e: React.MouseEvent) => {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  return (
    <>
      <ButtonCore
        title={props.title}
        dataCy={props.dataCy}
        id={props.id}
        type={props.type || ButtonTypes.Button}
        variant={ButtonVariantsCore.Primary}
        size={props.size || ButtonSizes.MD}
        styles={btnStyles}
        hoverStyles={btnStylesHover}
        className={classNames(
          props.classNames,
          styles.button,
          props.variant === ButtonVariants.Primary && styles.primary,
          props.variant === ButtonVariants.Secondary && styles.secondary,
          props.variant === ButtonVariants.Tertiary && styles.tertiary,
          props.variant === ButtonVariants.Link && styles.link,
          props.variant === ButtonVariants.Transparent && styles.transparent,
          props.disabled && styles.disabled,
          props.size ? styles[props.size] : styles['md'],
          props.isUppercase && styles.isUppercase
        )}
        disabled={props.disabled}
        onClick={handleOnClick}
        ariaLabel={props.ariaLabel}
      >
        {props.inProgress && (
          <Icon
            iconVariant={Icon.Variants.FontAwesome}
            icon="fas fa-sync-alt"
            className={styles.progressIcon}
          />
        )}

        {props.children}
      </ButtonCore>
    </>
  );
};

Button.Variants = ButtonVariants;
Button.Sizes = ButtonSizes;
Button.Types = ButtonTypes;

export default Button;
